import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MonasteryAbandoned3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MONASTERY_ABANDONED3;
}

export default MonasteryAbandoned3PoiTileEntity;
